module.exports = __webpack_public_path__ + "img/patrocinadores-2024.50e9512d.jpg";